import React, { useState, useEffect, useRef } from 'react'
import { Table, Text, InfoSignIcon, Pane } from 'evergreen-ui'
import { Money } from '../../Misc'

import './Material.scss'
import { isMaterialsEqual } from './MaterialFuncs'

export function MaterialTable(props) {

    let { Materials } = props;
    const [search, setSearch] = React.useState(0);
    const [material, selMaterial] = React.useState(props.selMaterial);
    var lastType = null;
    var lastSubType = null;

    useEffect(() => {
        if (props.selMaterial != material)
            props.onSelectMaterial(material)
    }, [material])

    var typeheader = null;

    return (
        <Table className="MaterialTable">
            <Table.Head>
                <Table.SearchHeaderCell onChange={(value) => setSearch(value)} />
                <Table.TextHeaderCell textAlign="right">Thickness (mm)</Table.TextHeaderCell>
                {/* <Table.TextHeaderCell textAlign="right">Price Each</Table.TextHeaderCell> */}
                <Table.TextHeaderCell textAlign="right">Status</Table.TextHeaderCell>
            </Table.Head>
            <Table.Body height={300}>
                {
                    Materials && Object.keys(Materials).filter((key) => {
                        if (!search) return true;
                        let thismaterial = Materials[key]
                        return thismaterial.Material.toLowerCase().includes(search.toLowerCase()) ||
                            thismaterial.Mgroup.toLowerCase().includes(search.toLowerCase()) ||
                            thismaterial.SubGroup.toLowerCase().includes(search.toLowerCase()) ||
                            thismaterial.Thickness.toLowerCase().includes(search.toLowerCase());
                    }).map((key, index) => {
                        let thismaterial = Materials[key]
                        typeheader = null
                        if (lastType != thismaterial.Mgroup + thismaterial.SubGroup) {
                            lastType = thismaterial.Mgroup + thismaterial.SubGroup
                            typeheader = lastType;
                        }

                        let isSelected = material && isMaterialsEqual(material, thismaterial);
                        return <Pane key={index}>
                            {props.showHeadings && typeheader && <Table.Row key={'subhead' + thismaterial.Mgroup + thismaterial.SubGroup + index} height={35}><Table.TextCell style={{ textAlign: "left" }} colSpan={4}>
                                <h2>{thismaterial.Mgroup} - <small>{thismaterial.SubGroup}</small></h2></Table.TextCell></Table.Row>}
                            <Table.Row key={thismaterial.material + thismaterial.Mgroup + thismaterial.SubGroup + thismaterial.Thickness} height={35} isSelectable
                                onSelect={() => {
                                    // console.log(thismaterial);
                                    selMaterial(thismaterial);
                                }}
                                style={{ backgroundColor: (isSelected) ? '#206BE1' : '' }}
                                className={index == 0 ? 'first' : ''}
                            >
                                <Table.TextCell style={{ textAlign: 'left' }}>

                                    <Text color={(isSelected) ? '#FFFFFF' : ''}>
                                    {thismaterial.Caption || thismaterial.Material}
                                    {thismaterial.InfoURL &&
                                            <a href={thismaterial.InfoURL} target="_blank"><InfoSignIcon color="info" marginLeft={8} /></a>}</Text>
                                </Table.TextCell>
                                <Table.TextCell style={{ textAlign: 'right' }}>
                                    <Text color={(isSelected) ? '#FFFFFF' : ''}>{thismaterial.Thickness > 0
                                        ? thismaterial.Thickness : ''}</Text>
                                </Table.TextCell>
                                {/* <Table.TextCell style={{ textAlign: 'right' }}>
                                    <Text color={(isSelected) ? '#FFFFFF' : ''}>{thismaterial.Available == 'Online' ? <Money>{thismaterial.cost}</Money> : ''}</Text>
                                </Table.TextCell>
                                <Table.TextCell style={{ textAlign: 'right' }}>
                                    <Text color={(isSelected) ? '#FFFFFF' : ''}>{thismaterial.Available == 'Online' ? <Money>{thismaterial.qtycost}</Money> : thismaterial.Available}</Text>
                                </Table.TextCell> */}
                                <Table.TextCell style={{ textAlign: 'right' }}>
                                    <Text color={(isSelected) ? '#FFFFFF' : ''}>{thismaterial.Available == 'Online' ? 'In Stock' : thismaterial.Available}</Text>
                                </Table.TextCell>
                            </Table.Row>

                        </Pane>
                    })
                }
            </Table.Body>
        </Table >
    )
}

